import { Component, OnInit, Input, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { CourseWithQuantity } from '../Models/courseWithQuantity.model';
import { RegistrationModel, CourseRegistrationModel, AttendeeModel } from '../Models/registration.model';
import { IPayPalConfig, ICreateOrderRequest, ITransactionItem } from 'ngx-paypal';
import { Router } from '@angular/router';
import { SnotifyService, SnotifyPosition } from 'ng-snotify';
import { ContactService } from '../Services/contact.service';
import { CartItemsCookieService } from '../Services/cartItemsCookie.service';
import { Subject } from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import { InteracDialogComponent } from '../interac-dialog/interac-dialog.component';
import { Course } from '../Models/course.model';

@Component({
  selector: 'app-registration-course-card',
  templateUrl: './registration-course-card.component.html',
  styleUrls: ['./registration-course-card.component.css']
})
export class RegistrationCourseCardComponent implements OnInit {

  @Input()
  addedCoursesWithQuantity: CourseWithQuantity[];

  @Input()
  registrationType: string;

  showPaypalButton = false;

  public payPalConfig?: IPayPalConfig;

  courseRegistrationArray: CourseRegistrationModel[];

  constructor(
    private _router: Router,
    private snotifyService: SnotifyService,
    private contactService: ContactService,
    private cartItemsCookieService: CartItemsCookieService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {

    console.log('addedCoursesWithQuantity', this.addedCoursesWithQuantity)

    this.generatecourseRegistrationArray();
    this.initConfig();
  }

  openDialog() {
    const dialogRef = this.dialog.open(InteracDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  generatecourseRegistrationArray(){
    var newcourseRegistrationArray = [];
    this.addedCoursesWithQuantity.forEach((courseWrap) => {
      var courseReg = new CourseRegistrationModel();
      courseReg.courseId = courseWrap.course.id;
      courseReg.courseName = courseWrap.course.name;

      if(this.registrationType == 'standard'){
        courseReg.courseFee = courseWrap.course.fee;
      }else{
        courseReg.courseFee = courseWrap.course.studentFee;
      }
      
      courseReg.quantity = courseWrap.quantity;
      courseReg.attendees = [];
      for(var i=1; i<=courseWrap.quantity; i++){
        courseReg.attendees.push(new AttendeeModel("","","","","","","","","","",""));
      }
      newcourseRegistrationArray.push(courseReg);
    });

    this.courseRegistrationArray = newcourseRegistrationArray;
    console.log(' this.courseRegistrationArray',  this.courseRegistrationArray);
  }

  initConfig(): void {
      this.payPalConfig = {
      currency: 'CAD',
      clientId: 'AdOe7pZCZsK2M38G3CorZd0k6uWAOY3igOtsB_SigGn2c589AGU5e9RVp-7F1wxEQSvuyzfBtXQMp16n',
      createOrderOnClient: (data) => <ICreateOrderRequest>{
        intent: 'CAPTURE',
        purchase_units: [
          {
            amount: {
              currency_code: 'CAD',
              value: this.getTotalAmount().toString(),
              breakdown: {
                item_total: {
                  currency_code: 'CAD',
                  value: this.getTotalAmount().toString()
                }
              }
            },
            items: this.getItemsInOrder()
          }
        ]
      },
      advanced: {
        commit: 'true'
      },
      style: {
        label: 'paypal',
        layout: 'vertical'
      },
      onApprove: (data, actions) => {
        this.snotifyService.success(`Transaction approved`, {position: SnotifyPosition.rightTop});
        console.log('onApprove - transaction was approved, but not authorized', data, actions);
        actions.order.get().then(details => {
          console.log('onApprove - you can get full order details inside onApprove: ', details);
        });
      },
      onClientAuthorization: (data) => {
        console.log('onClientAuthorization - you should probably inform your server about completed transaction at this point', data);
        this.contactService.saveRegistrationRequest(this.courseRegistrationArray).toPromise()
        .then((res) => {
          console.log('res', res);
          this.snotifyService.success(`Successfully registered`, {position: SnotifyPosition.rightTop, timeout: 10000});
          this.showPaypalButton = false;
          // // // Remove cookie and redirect to home
          this.cartItemsCookieService.emptyCart();

          window.location.href = "/home";
      
        });
        // this.showSuccess = true;
      },
      onCancel: (data, actions) => {
        console.log('OnCancel', data, actions);
        this.showPaypalButton = true;
        this.snotifyService.error(`Transaction cancelled, please try again`, {position: SnotifyPosition.rightTop});
      },
      onError: err => {
        console.log('OnError', err);
        this.showPaypalButton = true;
        this.snotifyService.error(`Something went wrong, please try again`, {position: SnotifyPosition.rightTop});
      },
      onClick: (data, actions) => {
        console.log('onClick', data, actions);
      },
    };
  }



  getItemsInOrder(): ITransactionItem[]{
    var items: ITransactionItem[] = [];
    this.addedCoursesWithQuantity.forEach((courseWrap) => {
      var item: ITransactionItem =  {
        name: courseWrap.course.name,
        quantity: courseWrap.quantity.toString(),
        category: 'DIGITAL_GOODS',
        unit_amount: {
          currency_code: 'CAD',
          value: this.getCourseFee(courseWrap.course),
        },
      }

      items.push(item);
    });
    return items;
  }

  getCourseFee(course: Course){
    if(this.registrationType == 'standard'){
      return course.fee.toString();
    }else{
      return course.studentFee.toString();
    }
  }

  getTotalAmount(){
    var sum = 0;
    this.addedCoursesWithQuantity.forEach((courseWrap) => {
      if(this.registrationType == 'standard'){
        sum = sum + courseWrap.quantity * courseWrap.course.fee;
      }else{
        sum = sum + courseWrap.quantity * courseWrap.course.studentFee;
      }   
    });
    return sum;
  }

  registrationFormSubmitted(regArray: CourseRegistrationModel[]){
    console.log('form submitted: ',  regArray);
    this.courseRegistrationArray = regArray;
    this.showPaypalButton = true;

    setTimeout(function(){
      document.querySelector("#paymentOptions").scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 0);
  }

  // getcourseRegistrationArray(courseWrap: CourseWithQuantity){

  //   var registrationsArray = [];
  //   for(var i=1; i<=courseWrap.quantity; i++){
  //     var reg = new RegistrationModel();
  //     reg.courseId = courseWrap.course.id;
  //     registrationsArray.push(reg);
  //   }
  //   return registrationsArray;

  //   // var numberArray = [];
  //   // for(var i=1; i<=num; i++){
  //   //   numberArray.push(i);
  //   // }
  //   // return numberArray;
  // }

}



// WEBPACK FOOTER //
// ./src/app/registration-course-card/registration-course-card.component.ts